module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[3]),
      expression: "getScreenSize < 2 && !delayedLoading[3]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/weather/Weather')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.device),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "device", $$v)
      },
      expression: "getSettingsWeather.device"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/NoWeather'),
      "value": "NaN"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/reinhardt'),
      "value": "5MV"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/reinhardtRain'),
      "value": "5MVRain"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/thiesClima'),
      "value": "THIES"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/vaisala'),
      "value": "WXT520"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/weather/kw360'),
      "value": "KW360"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-form-item', {
    staticClass: "el-form-item-full pixel"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.setDeviceLoading
    },
    on: {
      "click": function($event) {
        return _vm.setDevice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/weather/SetDevice')))])], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-row', [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/weather/values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsWeather.valsel), function(item, i) {
    return _c('el-col', {
      key: item.name,
      attrs: {
        "md": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.name
      }
    }, [_c('el-color-picker', {
      model: {
        value: (_vm.getUnsavedLocalSettings.interface.colorsweath[i]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.interface.colorsweath, i, $$v)
        },
        expression: "getUnsavedLocalSettings.interface.colorsweath[i]"
      }
    }), _vm._v(" "), _c('el-switch', {
      staticClass: "switch-align",
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1)], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002e03f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Weather.vue
// module id = 437
// module chunks = 1